import RingtonesResource from 'flow/api/ringtones';
import Actions from 'flow/actions';

import { httpGetErrorDispatcher } from 'flow/actions/app-actions';
import { RingTonePlayer } from 'resources/ringtone-player';
import { getRingtoneUrl } from 'flow/utils/ringtone-utils';

export const fetchRingtoneSettings = (callback) => (dispatch) => {
    RingtonesResource.getRingtoneSettings({
        onResult(json) {
            dispatch(receiveRingtoneSettings(json));
            if (typeof callback === 'function') {
                callback(json);
            }
        },
        onError: httpGetErrorDispatcher(dispatch),
    });
};

export const fetchRingtonesList = () => (dispatch) => {
    RingtonesResource.getRingtones({
        onResult(json) {
            dispatch(receiveRingtonesList(json));
        },
        onError: httpGetErrorDispatcher(dispatch),
    });
};

export const setRingtoneSettings = (ringtoneEntityKey) => (dispatch) => {
    RingTonePlayer.setUrl(getRingtoneUrl(ringtoneEntityKey));
    RingtonesResource.setRingtoneSettings(
        {
            onResult(json) {
                dispatch(receiveRingtoneSettings(json));
            },
        },
        ringtoneEntityKey,
    );
};

export const preloadSelectedRingtone = () => (dispatch) => {
    fetchRingtoneSettings((json) => {
        const ringtoneEntityKey = json && json.key;
        RingtonesResource.getRingtoneAudio(
            {
                onResult() {
                    RingTonePlayer.setUrl(getRingtoneUrl(ringtoneEntityKey));
                },
                onError: httpGetErrorDispatcher(dispatch),
            },
            ringtoneEntityKey,
        );
    })(dispatch);
};

const receiveRingtonesList = (json) => ({
    type: Actions.RESULT_RINGTONES_LIST,
    data: json,
});

const receiveRingtoneSettings = (json) => ({
    type: Actions.RESULT_RINGTONE_SETTINGS,
    data: json,
});
